module.exports = __webpack_public_path__ + "static/media/MyDonation_01.fb655ba2.jpg";